import { create } from 'zustand'
import { persist, devtools, createJSONStorage } from 'zustand/middleware'
import { Currency } from '@/global/currencies'

export type YearMonth = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12'

export type TimeframeSettings = {
  isActive: boolean
  startAt: string | null
  endAt: string | null
}

export interface FinancialModelSettings {
  general: {
    name: string
    revenue_stream_name: string
    revenue_stream_type: string
  }
  currency: {
    functionalCurrency: Currency
  }
  fiscalYearEnd: {
    companyFiscalYearEnd: YearMonth
  }
  timeframe: {
    historical: TimeframeSettings
    forecast: TimeframeSettings
  }
  financialModelUpdate: {
    actualData: {
      isActive: boolean
      startAt: string | null
      endAt: string | null
    }
  }
}
export interface FinancialModelSettingsStore {
  settings: Record<string, Partial<FinancialModelSettings>>
  setModelSettings: (modelId: string, settings: Partial<FinancialModelSettings>) => void
  resetFinancialModel: () => void
}

export const useFinancialModelSettingsStore = create<FinancialModelSettingsStore>()(
  devtools(
    persist(
      set => ({
        settings: {},
        setFullSettings: (settings: Record<string, Partial<FinancialModelSettings>>) => set({ settings }),
        setModelSettings: (modelId: string, settings: Partial<FinancialModelSettings>) =>
          set(prev => ({
            settings: {
              ...prev.settings,
              [modelId]: {
                ...prev.settings[modelId],
                ...settings
              }
            }
          })),
        resetFinancialModel: () => set({ settings: {} })
      }),
      {
        name: `financialModelSettings`,
        storage: createJSONStorage(() => localStorage)
      }
    )
  )
)
